export const recruiterTypeList = [
  { name: "Select", id: "0" },
  { name: "Direct Employer", id: "1" },
  { name: "Recruitment Firm", id: "2" },
];